<template>
  <div class="modal">
    <div class="modal-box">
      <ButtonSquare
        class="close-button"
        :imgSource="iconCloseCross"
        size="small"
        @clicked="closeModal"
      />

      <VuePannellum
        width="100%"
        height="100%"
        :showFullscreen="true"
        :showZoom="true"
        :src="pannoramaUrl"
      />
    </div>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import VuePannellum from 'vue-pannellum/src/vue-pannellum.vue'
import iconCloseCross from '@/assets/icons-general/icon-close-cross-small.svg'
import ButtonSquare from '@/components/general/buttons/ButtonSquare/ButtonSquare.vue'
import { useStore } from 'vuex'

const store = useStore()
const pannoramaUrl = computed(() => store.state.pannoramaUrl)

function closeModal() {
  window.URL.revokeObjectURL(pannoramaUrl.value)
  store.commit('SET_CURRENT_PANORAMA_URL', '')
  store.commit('SET_STATUS_ON_SHOW_OVERLAY_MODAL', { toggleModal: false })
}
</script>

<style lang="scss" scoped>
@use '@/design-system/design-tokens/variables.scss';
@use '@/design-system/design-tokens/mixins.scss';
@use '@/styles/variables' as old-variables;

.modal-box {
  height: 100%;
  position: relative;
}
.modal {
  position: fixed;
  top: calc(50% + variables.$layout-top-bar-height / 2);
  transform: translateY(-50%);
  left: calc(100vw * 0.05);
  background: old-variables.$color-grey-lighter;
  border-radius: 2px;
  width: calc(100vw * 0.9);
  max-height: 90%;
  height: 80%;
  overflow: hidden;
  @include mixins.scrollbar-vertical;
}

.close-button {
  cursor: pointer;
  position: absolute;
  border-radius: 4px;
  margin-right: -16px;
  margin-top: 4px;
  right: 0px;
  color: old-variables.$color-grey-blue-dark;
  z-index: 10;
}

@media screen and (max-width: 1024px) {
  .modal-box {
    width: 100%;
    color: white;
    flex-direction: column;
    border-radius: 0;
    z-index: 80;
  }
  .modal {
    position: fixed;
    transform: none;
    top: 64px;
    width: 100vw;
    height: 82vh;
    left: 0px;
    right: 0px;
    z-index: 80 !important;
  }
  .close-button {
    position: absolute;
    margin-right: 3px;
    margin-top: 10px;
  }
}
</style>
